/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener('DOMContentLoaded', function () {
    const subCollectionCards = document.querySelectorAll('.shopify-section--sub-collection .sub-collection-card');
    if(subCollectionCards.length > 1) {
        const subCollectionSlider = new Swiper('.sub-collection:not(.no-featured-collection) .sub-collections-wrapper',{
            spaceBetween: 10,
            navigation: {
                nextEl: '.shopify-section--sub-collection .swiper-button-next',
                prevEl: '.shopify-section--sub-collection .swiper-button-prev'
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
              },
            breakpoints: {
                0: {
                    slidesPerView: 1.5,
                },
                424: {
                    slidesPerView: subCollectionCards.length > 2 ? 2: subCollectionCards.length
                },
                512: {
                    slidesPerView: subCollectionCards.length > 2.4 ? 2.4: subCollectionCards.length
                },
                767: {
                    slidesPerView: subCollectionCards.length > 4 ? 4: subCollectionCards.length
                },
                1024: {
                    slidesPerView: subCollectionCards.length > 2.4 ? 2.4: subCollectionCards.length
                },
                1120: {
                    slidesPerView: subCollectionCards.length > 2.7 ? 2.7: subCollectionCards.length
                },
                1200: {
                    slidesPerView: subCollectionCards.length > 3 ? 3: subCollectionCards.length
                },
                1280: {
                    slidesPerView: subCollectionCards.length > 3.6 ? 3.6: subCollectionCards.length
                },
                1366: {
                    slidesPerView: subCollectionCards.length > 3.9 ? 3.9: subCollectionCards.length,
                },
                1440: {
                    slidesPerView: subCollectionCards.length > 4 ? 4.12 : subCollectionCards.length
                }
            }
        });
        const subCollectionSliderNoFeatured = new Swiper('.sub-collection.no-featured-collection .sub-collections-wrapper',{
            spaceBetween: 10,
            navigation: {
                nextEl: '.shopify-section--sub-collection .swiper-button-next',
                prevEl: '.shopify-section--sub-collection .swiper-button-prev'
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
              },
            breakpoints: {
                0: {
                    slidesPerView: 1.5,
                },
                424: {
                    slidesPerView: 1.8
                },
                512: {
                    slidesPerView: subCollectionCards.length > 2 ? 2: subCollectionCards.length
                },
                767: {
                    slidesPerView: subCollectionCards.length > 2.4 ? 2.4: subCollectionCards.length
                },
                1024: {
                    slidesPerView: subCollectionCards.length > 2.8 ? 2.8: subCollectionCards.length
                },
                1120: {
                    slidesPerView: subCollectionCards.length > 3.2 ? 3.2: subCollectionCards.length
                },
                1200: {
                    slidesPerView: subCollectionCards.length > 3.6 ? 3.6: subCollectionCards.length
                },
                1280: {
                    slidesPerView: subCollectionCards.length > 4.2 ? 4.2: subCollectionCards.length
                },
                1366: {
                    slidesPerView: subCollectionCards.length > 4.5 ? 4.5: subCollectionCards.length,
                },
                1440: {
                    slidesPerView: subCollectionCards.length > 5 ? 5: subCollectionCards.length
                }
            }
        });
        for (const [index,subCollectionCard] of subCollectionCards.entries()) {
            if(subCollectionCard.classList.contains('selected')) {
                subCollectionSlider.slideTo(index);
                break;
            }
        }
        for (const [index,subCollectionCard] of subCollectionCards.entries()) {
            if(subCollectionCard.classList.contains('selected')) {
                subCollectionSliderNoFeatured.slideTo(index);
                break;
            }
        }
    }
  })

  const href = location.href;
  const productsDataArr = [];
  const i = href.indexOf("?page=");

  if (i != -1) {
    window.location = href.substring(0, i);
  }

  let currentPageNumber = 1;

  document.addEventListener("click", (e) => {
    if (e.target.classList.contains('collection-load-more')) {
      const loadMoreButton = document.querySelector(".collection-load-more");

      let limitNumber = parseInt(loadMoreButton.getAttribute("limit"));

      const productContainer = document.querySelector(".collection__products .product-grid");

      const j = href.indexOf("/collections/");
      const _url = location.href
      ++currentPageNumber;
      const hasParams = _url.includes('?') && _url.split('?')[1].length > 0;
      let url = `${location.href.substring(j)}?page=${currentPageNumber}`;
      if(hasParams) {
        url = `${location.href.substring(j)}&page=${currentPageNumber}`;
      }
      fetch(url)
        .then((res) => res.text())
        .then((res) => {
          const parser = new DOMParser();
          const html = parser.parseFromString(res, "text/html");
          const productItems = html.querySelectorAll(".product-item");

          if (productItems.length > 0) {
            for(let i = 0; i < productItems.length; i++) {
              productContainer.appendChild(productItems[i]);
            }
            
            if (productItems.length < limitNumber) {
              loadMoreButton.style.display = "none";
            }
          }
          
        })
        .catch((err) => {
          console.log(err);
        });
    }
  })

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

document.querySelectorAll('.lg-accordion').forEach(accordion => {
    accordion.addEventListener('toggle', function() {
      const content = accordion.querySelector('.lg-accordion__body');
      if (accordion.open) {
        content.style.maxHeight = content.scrollHeight + "px"; 
      } else {
        content.style.maxHeight = "0";
      }
    });
  });
  
  document.addEventListener('DOMContentLoaded', function () {
    scrollSlider();
  });
  
  function scrollSlider () {
    document.querySelectorAll('.scroll-slider').forEach(slider => {
        // Set the number of dots
        const numberOfDots = 4;
  
        // Create the dot container
        let scrollContainer = slider.querySelector('.scroll');
        let prevButton = slider.querySelector('.scroll_prev');
        let nextButton = slider.querySelector('.scroll_next');
        let dotsContainer = slider.querySelector('.dots-container');
  
        if (!prevButton && !nextButton) {
            slider.innerHTML += `<div class="slider-button scroll_prev hide"></div><div class="slider-button scroll_next"></div>`
        }
  
        if (!dotsContainer) {
            slider.innerHTML += `<div class="dots-container"></div>`;
        }
  
        scrollContainer = slider.querySelector('.scroll');
        prevButton = slider.querySelector('.scroll_prev');
        nextButton = slider.querySelector('.scroll_next');
        dotsContainer = slider.querySelector('.dots-container');
  
        if (scrollContainer && scrollContainer.children.length <= 0) {
            slider.style.display = "none";
        }
  
        // Determine scroll amount based on the number of dots
        const scrollAmount = scrollContainer.scrollWidth / numberOfDots;
  
        // Create dots based on the defined number of dots
        if (dotsContainer.children.length <= 0) {
            for (let i = 0; i < numberOfDots; i++) {
                const dot = document.createElement('div');
                dot.classList.add('dot');
                dot.dataset.index = i;  // Store the index in a data attribute
                dotsContainer.appendChild(dot);
            }
        }
  
        // Set initial active dot
        updateActiveDot(scrollContainer, dotsContainer);
  
        // Listen for scroll changes to update buttons and dots
        scrollContainer.addEventListener('scroll', () => {
            updateButtonsVisibility(scrollContainer, prevButton, nextButton);
            updateActiveDot(scrollContainer, dotsContainer);
        });
  
        // Activate dot on click
        dotsContainer.addEventListener('click', (e) => {
            if (e.target.classList.contains('dot')) {
                const index = parseInt(e.target.dataset.index, 10);
                const targetScrollLeft = index * scrollAmount; // Calculate the target scroll position based on index
                
                smoothScrollTo(scrollContainer, targetScrollLeft, 500, () => {
                    updateButtonsVisibility(scrollContainer, prevButton, nextButton);
                    updateActiveDot(scrollContainer, dotsContainer);
                });
            }
        });
    });
  
    document.addEventListener('click', function (e) {
        if (e.target.classList.contains('slider-button')) {
            const slider = e.target.closest('.scroll-slider');
            const scrollContainer = slider?.querySelector('.scroll');
            const prevButton = slider?.querySelector('.scroll_prev');
            const nextButton = slider?.querySelector('.scroll_next');
  
            if (scrollContainer) {
                const scrollAmount = scrollContainer.scrollWidth / 4; // Adjust based on the number of dots
                const direction = e.target.classList.contains('scroll_prev') ? -scrollAmount : scrollAmount;
  
                smoothScrollTo(scrollContainer, scrollContainer.scrollLeft + direction, 500, () => {
                    updateButtonsVisibility(scrollContainer, prevButton, nextButton);
                    updateActiveDot(scrollContainer, slider.querySelector('.dots-container'));
                });
            }
        }
    });
  }
  
  /**
  * Smooth scrolling function
  */
  function smoothScrollTo(element, target, duration, callback) {
    const start = element.scrollLeft;
    const change = target - start;
    const startTime = performance.now();
  
    function animateScroll(currentTime) {
        const elapsedTime = currentTime - startTime;
        const progress = Math.min(elapsedTime / duration, 1);
        const easeInOutQuad = progress < 0.5 
            ? 2 * progress * progress 
            : -1 + (4 - 2 * progress) * progress;
  
        element.scrollLeft = start + change * easeInOutQuad;
  
        if (elapsedTime < duration) {
            requestAnimationFrame(animateScroll);
        } else if (callback) {
            callback(); // Ensure buttons update after scrolling
        }
    }
  
    requestAnimationFrame(animateScroll);
  }
  
  /**
  * Hide or show slider buttons based on scroll position
  */
  function updateButtonsVisibility(scrollContainer, prevButton, nextButton) {
    const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;
  
    prevButton.classList.toggle('hide', scrollContainer.scrollLeft <= 0);
    nextButton.classList.toggle('hide', scrollContainer.scrollLeft >= maxScrollLeft);
  }
  
  /**
  * Update the active dot based on the scroll position
  */
  function updateActiveDot(scrollContainer, dotsContainer) {
    if (!scrollContainer.children.length) return;
    const slideWidth = scrollContainer.scrollWidth / dotsContainer.children.length; // Calculate based on number of dots
    const index = Math.ceil(scrollContainer.scrollLeft / slideWidth);
  
    dotsContainer.querySelectorAll('.dot').forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
    });
  }

  // Initialize dropdown variant picker
function initializeDropdownVariantPickers(container) {
    const targetContainer = container || document;
    
    targetContainer.querySelectorAll('.dropdown-variant__picker').forEach(picker => {
        // Skip if already initialized
        if (picker.hasAttribute('data-dropdown-initialized')) return;
        picker.setAttribute('data-dropdown-initialized', 'true');

        const option_title = picker.querySelector('.dropdown_toggle');
        
        // Get sold out text from the closest wrapper with data attribute
        let soldOutTextWrapper = picker.closest('[data-sold-out-text-wrapper]');
        let soldOutText = soldOutTextWrapper ? soldOutTextWrapper.getAttribute('data-sold-out-text') : null;

        if (!soldOutText) {
            soldOutText = "Sold out";
        }

        picker.querySelectorAll('input').forEach(input => {
            input.addEventListener('click', function (e) {
                if (option_title) {
                    const toggleButton = option_title;
                    
                    if (input.classList.contains('sold-out')) {
                        toggleButton.querySelector('.option_title').innerHTML = `${picker.dataset.optionName} ${input.value} - ${soldOutText}`;
                        toggleButton.classList.add('sold-out-selected');
                    } else if(input.classList.contains('unavailable')) {
                        toggleButton.querySelector('.option_title').innerHTML = `${picker.dataset.optionName} ${input.value} - Unavailable`;
                        toggleButton.classList.add('sold-out-selected');
                    } else {
                        toggleButton.querySelector('.option_title').innerHTML = `${picker.dataset.optionName} ${input.value}`;
                        toggleButton.classList.remove('sold-out-selected');
                    }

                    toggleButton.setAttribute('data-btn-variant-id', input.dataset.valueVariantId)
                }
            })
        })
    })
}

window.addEventListener('DOMContentLoaded', function () {
    // Initialize on page load
    initializeDropdownVariantPickers();

    // Initialize for quick view drawer when it opens
    document.addEventListener('theme:quick-add:open', function() {
        setTimeout(function() {
            initializeDropdownVariantPickers();
        }, 100);
    });

    document.addEventListener('click', function (e) {
        if (e.target.classList.contains('dropdown_toggle')) {
            if (e.target.closest('.dropdown-variant__picker').classList.contains('open')) {
                e.target.closest('.dropdown-variant__picker').classList.remove('open')
            } else {
                e.target.closest('.dropdown-variant__picker').classList.add('open')
            }
        } else {
            document.querySelectorAll('.dropdown-variant__picker').forEach(picker => {
                picker.classList.remove('open')
            })
        }
    })
})

function updateSplitColorLegendLabels(productSelector) {
    const standardWrapper = productSelector.querySelector('.selector-wrapper--standard-colors');
    const limitedWrapper = productSelector.querySelector('.selector-wrapper--limited-edition-colors');

    if (!standardWrapper && !limitedWrapper) {
        return null;
    }

    const checkedLimited = limitedWrapper?.querySelector('input[type="radio"][limited]:checked');
    const checkedStandard = standardWrapper?.querySelector('input[type="radio"]:checked:not([limited])')
        || standardWrapper?.querySelector('input[type="radio"]:checked');
    const standardValueEl = standardWrapper?.querySelector('[data-color-group-value="standard"]');
    const limitedOptionNameEl = limitedWrapper?.querySelector('[data-limited-option-name]');

    if (standardValueEl) {
        standardValueEl.textContent = checkedStandard && !checkedStandard.hasAttribute('limited')
            ? checkedStandard.value
            : '';
    }

    if (limitedOptionNameEl) {
        limitedOptionNameEl.textContent = 'Limited Edition';
    }

    return {
        isLimitedColor: !!checkedLimited,
        selectedColorValue: checkedLimited?.value || checkedStandard?.value || null,
    };
}

function syncColorGroupSelection(productSelector) {
    const standardWrapper = productSelector.querySelector('.selector-wrapper--standard-colors');
    const limitedWrapper = productSelector.querySelector('.selector-wrapper--limited-edition-colors');

    if (!standardWrapper || !limitedWrapper) return;

    const checkedLimited = limitedWrapper.querySelector('input[type="radio"][limited]:checked');
    const checkedStandard = standardWrapper.querySelector('input[type="radio"]:checked');

    if (checkedLimited && checkedStandard) {
        checkedStandard.checked = false;
    }
}

function limitedEditionColor(container) {
    const targetContainer = container || document;
    const productSelectors = targetContainer.querySelectorAll('.product__selectors');

    productSelectors.forEach((productSelector) => {
        syncColorGroupSelection(productSelector);

        const colorState = updateSplitColorLegendLabels(productSelector);
        let isLimitedColor = colorState?.isLimitedColor || false;
        let selectedColorValue = colorState?.selectedColorValue || null;

        if (!colorState) {
            const colorWrapper = productSelector.querySelector(
                '.selector-wrapper--color:not(.selector-wrapper--standard-colors):not(.selector-wrapper--limited-edition-colors)'
            ) || productSelector.querySelector('.selector-wrapper--color');
            const checkedColorInput = colorWrapper?.querySelector('input[type="radio"]:checked');
            const hiddenColorInput = colorWrapper?.querySelector('[data-popout-input]');
            const fallbackValue = checkedColorInput?.value || hiddenColorInput?.value || null;

            if (fallbackValue) {
                isLimitedColor = checkedColorInput?.hasAttribute('limited')
                    || !!colorWrapper?.querySelector(`input[limited][value="${fallbackValue}"]`);
                selectedColorValue = fallbackValue;
            }
        }

        const productContainer = productSelector.closest('[data-section-id]')
            || productSelector.closest('[data-quick-add-modal]')
            || productSelector.closest('.product');
        const imageBadge = productContainer?.querySelector('.product_color_limited_badge[data-limited-edition-color]');

        if (imageBadge) {
            if (isLimitedColor && selectedColorValue) {
                const labelText = imageBadge.querySelector('[data-limited-edition-label-text]');

                if (labelText) {
                    labelText.textContent = 'Limited Edition';
                } else {
                    imageBadge.textContent = 'Limited Edition';
                }

                imageBadge.style.display = 'block';
            } else {
                imageBadge.style.display = 'none';
            }
        }
    });
}

function initLimitedEditionColorListeners(container) {
    const targetContainer = container || document;

    targetContainer.querySelectorAll('.product__selectors tooltip-component').forEach(tooltipComponent => {
        if (tooltipComponent.hasAttribute('data-limited-initialized')) return;
        tooltipComponent.setAttribute('data-limited-initialized', 'true');

        tooltipComponent.addEventListener('click', function () {
            const productSelector = this.closest('.product__selectors');
            if (!productSelector) return;

            const productContainer = productSelector.closest('[data-section-id]')
                || productSelector.closest('[data-quick-add-modal]');

            updateSplitColorLegendLabels(productSelector);
            limitedEditionColor(productContainer || productSelector);
        });
    });

    targetContainer.querySelectorAll(
        '.selector-wrapper--standard-colors input[type="radio"], .selector-wrapper--limited-edition-colors input[type="radio"], .selector-wrapper--color:not(.selector-wrapper--standard-colors):not(.selector-wrapper--limited-edition-colors) input[type="radio"]'
    ).forEach(input => {
        if (input.hasAttribute('data-limited-listener')) return;
        input.setAttribute('data-limited-listener', 'true');

        input.addEventListener('change', function() {
            const productSelector = this.closest('.product__selectors');
            if (!productSelector) return;

            const productContainer = productSelector.closest('[data-section-id]')
                || productSelector.closest('[data-quick-add-modal]');

            syncColorGroupSelection(productSelector);
            limitedEditionColor(productContainer || productSelector);
        });
    });
}

document.addEventListener('theme:variant:change', function(e) {
    const productContainer = e.target;
    if (!productContainer) return;

    productContainer.querySelectorAll('.product__selectors').forEach((productSelector) => {
        updateSplitColorLegendLabels(productSelector);
    });

    limitedEditionColor(productContainer);
});

window.addEventListener('DOMContentLoaded', function () {
    limitedEditionColor();
    initLimitedEditionColorListeners();

    document.addEventListener('theme:quick-add:open', function() {
        setTimeout(function() {
            limitedEditionColor();
            initLimitedEditionColorListeners();
        }, 100);
    });
});